import { type SlimCold } from '@owl-nest/cold-data/client'
import type * as contentful from '@boutique/contentful'

import { ExtraPillar, MediumTag, PartialTag } from './tag/index.ts'

export function buildTags(
  slugs: string[],
  cold: {
    tags: SlimCold['tags']
    taxonomies: SlimCold['taxonomies']
  },
): {
  categories: PartialTag[]
  environmentalPillars: MediumTag<ExtraPillar>[]
  productTypes: PartialTag[]
  socialPillars: MediumTag<ExtraPillar>[]
  others: PartialTag[]
} {
  const categories: PartialTag[] = []
  const environmentalPillars: MediumTag<ExtraPillar>[] = []
  const productTypes: PartialTag[] = []
  const socialPillars: MediumTag<ExtraPillar>[] = []
  const others: PartialTag[] = []

  const seen = new Set()

  for (const slug of slugs) {
    const tag = cold.tags[slug]
    if (tag === undefined) {
      continue
    }

    const parents = tag.parents.map((taxonomySlug) => cold.taxonomies[taxonomySlug])

    let inSpecialTaxonomy = false
    let type: undefined | contentful.taxonomy.TaxonomyType = undefined

    for (const taxonomy of parents) {
      if (!taxonomy || !taxonomy.type) {
        continue
      }

      if (['size', 'color', 'gender'].includes(taxonomy.type)) {
        inSpecialTaxonomy = true
        type = undefined
        break
      }

      if (['category', 'moment', 'social-pillar', 'environmental-pillar'].includes(taxonomy.type)) {
        inSpecialTaxonomy = true
        type = taxonomy.type
      }

      if (taxonomy.type === 'product-type' && slug === taxonomy.slug) {
        inSpecialTaxonomy = true
        type = 'product-type'
      }
    }

    if (inSpecialTaxonomy) {
      switch (type) {
        case 'category': {
          categories.push({
            slug: tag.slug,
            name: tag.name,
          })
          break
        }
        case 'product-type': {
          productTypes.push({
            slug: tag.slug,
            name: tag.name,
          })
          break
        }
        case 'environmental-pillar': {
          if (tag.pillar) {
            environmentalPillars.push({
              slug: tag.slug,
              name: tag.name,
              pillar: tag.pillar,
            })
          }
          break
        }
        case 'social-pillar': {
          if (tag.pillar) {
            socialPillars.push({
              slug: tag.slug,
              name: tag.name,
              pillar: tag.pillar,
            })
          }
          break
        }
      }
    } else {
      others.push({
        name: tag.name,
        slug: tag.slug,
      })
    }
  }

  return {
    categories,
    environmentalPillars,
    productTypes,
    socialPillars,
    others,
  }
}
